var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "73px",
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_compartir") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kiosko",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ficha",
    transform: "translate(-2012, -1766)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_compartir",
    transform: "translate(2012, 1766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.04,4.9932 L35.04,52.56 L37.9308,52.56 L37.9308,4.9932 L50.0488,17.1112 L52.122,15.038 L37.522,0.438 C36.938,-0.146 36.0328,-0.146 35.4488,0.438 L20.8488,15.038 L22.922,17.1112 L35.04,4.9932 Z M70.08,69.35 L70.08,43.8 L73,43.8 L73,69.35 C73,71.3648 71.3648,73 69.35,73 L3.65,73 C1.6352,73 0,71.3648 0,69.35 L0,43.8 L2.92,43.8 L2.92,69.35 C2.92,69.7588 3.2412,70.08 3.65,70.08 L69.35,70.08 C69.7588,70.08 70.08,69.7588 70.08,69.35 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareWhite);
export default __webpack_public_path__ + "static/media/share-white.5a676227fca423eb3c0e0723ee5fca16.svg";
export { ForwardRef as ReactComponent };